import type { Disposable } from '../common/disposable';

export function createDisposableTimeout(
    callback: () => void,
    delay: number
): Disposable {
    const id = setTimeout(callback, delay);
    return {
        dispose() {
            clearTimeout(id);
        },
    };
}
